export default class TiltEffect {
  constructor(selector, options = {}) {
    this.container = document.querySelector(selector);
    this.tiltLayer = this.container.querySelector('.tilt-layer');
    this.depthElement = this.container.querySelector('h1');

    this.maxTilt = options.maxTilt || 15;

    this.bindEvents();
  }

  bindEvents() {
    this.container.addEventListener('mousemove', (e) => this.onMouseMove(e));
    this.container.addEventListener('mouseleave', () => this.resetTilt());
  }

  onMouseMove(e) {
    // ✅ Désactive sur mobile
    if (!window.matchMedia('(min-width: 768px)').matches) return;

    const rect = this.container.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * this.maxTilt;
    const rotateY = ((x - centerX) / centerX) * this.maxTilt;

    this.tiltLayer.style.transform =
      `rotateX(${-rotateX}deg) rotateY(${rotateY}deg)`;

    this.depthElement.style.transform =
      `translateZ(${80 + rotateY}px)`;
  }

  resetTilt() {
    this.tiltLayer.style.transform = `rotateX(0deg) rotateY(0deg)`;
    this.depthElement.style.transform = `translateZ(80px)`;
  }
}
``